/**
 * 파일 객체에서 확장자를 반환합니다.
 * @param {object} file - 파일 객체
 * @property {string} name - 파일명
 * @returns {string|null} 파일확장자
 */
export default function getExtensionFromFile(file) {
  if (file && file.name) {
    const splitFileName = file.name.split('.');
    if (splitFileName.length > 1) {
      return splitFileName.pop().toLowerCase();
    }
  }
  return '';
}
